// @flow
import * as React from 'react'

import { Route, Redirect } from 'react-router-dom'
import { isSignedIn } from 'services/auth'
declare type Props = {
  children: React.Node,
}
const PrivateRoute = ({ children }: Props) => {
  const isAuthenticated = isSignedIn()
  return (
    <Route
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  )
}

export default PrivateRoute
